var parser = require('./parser');

module.exports = {
	parse: parser.parse
}
